function addressSingleLineFilter() {
    'ngInject';

    return (address) => {

        if (!address) {
            return;
        }
        if (!address.address1) {
            return;
        }

        let addr = '';
        addr += address.address1;
        if (address.address2 && (address.address2.length > 0)) {
            addr += ', ';
            addr += address.address2;
        }
        if (address.address3 && (address.address3.length > 0)) {
            addr += ', ';
            addr += address.address3;
        }
        if (address.address4 && (address.address4.length > 0)) {
            addr += ', ';
            addr += address.address4;
        }
        if (address.address5 && (address.address5.length > 0)) {
            addr += ', ';
            addr += address.address5;
        }
        if (address.postcode && (address.postcode.length > 0)) {
            addr += ', ';
            addr += address.postcode;
        }
        return addr;
    };
}

angular
    .module('BB')
    .filter('address_single_line', addressSingleLineFilter);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_filters/adress_single_line.filter.js